var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisible
    ? _c(
        "div",
        { class: _vm.rootClass, attrs: { "data-qa": "petition_banner" } },
        [
          _c(
            _setup.CorePRG,
            {
              attrs: {
                url: "https://www.roi.ru/142775/",
                "button-attrs": {
                  class: "d-flex",
                },
              },
              on: {
                click: function ($event) {
                  return _setup.sendYaGoal("petitionBanner__click")
                },
              },
            },
            [
              _c("img", {
                staticClass: "rounded",
                attrs: {
                  width: "100%",
                  height: "auto",
                  src: _setup.imageSrc,
                  alt: "Голосуй за безопасную медицину",
                },
              }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }